// extracted by mini-css-extract-plugin
export default {"works__container":"Works_works__container__uiBzd","works__title":"Works_works__title__krZCM","border":"Works_border__atT5A","works__content":"Works_works__content__ei44m"};